import { ApolloLink } from "@apollo/client";
import { ErrorHandler } from "@apollo/client/link/error";
import { useEnvContext } from "context/EnvContext";
import { APP_CAREPROVIDER } from "core/consts";
import { useToast } from "dsl/atoms/ToastNotificationContext";
import { useCallback } from "react";
import { useTranslations } from "translations";

export const useErrorHandler = (
  onError?: (errorHandler: ErrorHandler) => ApolloLink,
) => {
  const toast = useToast();
  const translations = useTranslations();
  const { app } = useEnvContext();

  const errorHandler = useCallback(
    (err: any) => {
      if (onError) onError(err);
      if (app === APP_CAREPROVIDER)
        toast({
          color: "danger",
          message: translations.auctionRequest.tryAgain,
        });
    },
    [onError, app],
  );

  return errorHandler;
};
